import React from 'react';
import PDFHeader from './PDFHeader';

interface PDFPage4Props {
  exclusions?: string[];
  renderedAt?: string;
}

const DEFAULT_EXCLUSIONS = [
'Entry tickets, boating and activity charges.',
'Meals not mentioned under package inclusions.',
'Personal expenses, tips and porterage.',
'Early check-in and late check-out.',
'Seat selection and excess baggage charges.',
'Additional sightseeing or vehicle usage.',
'Travel insurance and medical expenses.',
'Anything not specifically mentioned as included.',
];

const TERMS_AND_CONDITIONS = [
'This quotation is subject to availability until payment and confirmation.',
'Package prices may change before booking confirmation.',
'Standard hotel check-in is 2:00 PM and check-out is 11:00 AM.',
'Early check-in, late check-out and room preferences are subject to availability.',
'Flight timings, terminals and routes may change as per airline operations.',
'Sightseeing depends on weather, traffic, closures and local conditions.',
'Similar-category accommodation may be offered if the selected hotel is unavailable.',
'Vehicle usage is limited to the confirmed itinerary and schedule.',
'Unused or missed services are non-refundable.',
'Amendments are subject to availability and applicable charges.',
'Travellers must carry valid government-issued identification.',
'Supplier policies will apply to flights, hotels, transfers and activities.',
'OTA Prime Holidays may modify arrangements due to circumstances beyond its control.',
'Any dispute will be handled according to applicable Indian law.',
];

const renderList = (items: string[]) => (
  <ul>
    {items.map((item, index) => (
      <li key={`${item}-${index}`}>{item}</li>
    ))}
  </ul>
);

const PDFPage4: React.FC<PDFPage4Props> = ({ renderedAt }) => {
  return (
    <div className="pdf-page">
      <PDFHeader renderedAt={renderedAt} />
      <section className="pdf-section">
        <h2>🧾 Exclusions</h2>
        {renderList(DEFAULT_EXCLUSIONS)}

        <h2>📌 Terms & Conditions</h2>
        {renderList(TERMS_AND_CONDITIONS)}
        <footer className="pdf-footer">
          <p>Generated by OTA Prime Holidays</p>
        </footer>
      </section>
    </div>
  );
};

export default PDFPage4;
